// extracted by mini-css-extract-plugin
export var container = "_bd-1";
export var cornerButtonContainer = "_bd-5";
export var disabled = "_bd-2";
export var fileContainer = "_bd-4";
export var hiddenInput = "_bd-3";
export var widthContainer = "_bd-0";